import React from 'react';
import { MainLayout, Triptych } from '@app/components';
import { CatalogHeader } from '@app/features/Catalog';
import { useResourceScreenHelpers, useToast } from '@app/hooks';
import { catalogSnapshotApi } from '@app/store';
import { ICatalogSnapshot } from '@app/common';
import { useModal } from '@app/hooks/useModal';
import { CatalogSnapshotList } from '@app/features/CatalogSnapshot/CatalogSnapshotList';
import { CatalogSnapshotPublishModal } from '@app/features/CatalogSnapshot/CatalogSnapshotPublishModal';
import { CatalogSnapshotPublishModalId } from '@app/features/CatalogSnapshot/CatalogSnapshotPublishModal';
import { CatalogSnapshotShow } from '@app/features/CatalogSnapshot/CatalogSnapshotShow';

const extractApiCustomMessage = (error: any) => {
  return error?.data?.data?.message;
}

export const CatalogSnapshotScreen = () => {
  const toast = useToast();

  const modal = useModal(CatalogSnapshotPublishModalId);

  const [readOne, { isFetching }] = catalogSnapshotApi.useLazyReadOneCatalogSnapshotsQuery();

  const { triptych, selectedItem } = useResourceScreenHelpers<ICatalogSnapshot>();

  const [preview, { isLoading, error: apiErrors }] = catalogSnapshotApi.usePublishPreviewCatalogSnapshotMutation();

  const onPreview = async (catalogSnapshot: ICatalogSnapshot) => {
    try {
      const { url } = await preview({ catalogSnapshotId: catalogSnapshot._id }).unwrap();

      triptych.open({ mode: "UPDATE", data: { url } });

    } catch (error) {
      const message = extractApiCustomMessage(error) || 'Une erreur est survenue';

      toast.error(message, { autoClose: 5000 })
    }
  }

  return (
    <MainLayout header={<CatalogHeader />}>
      <CatalogSnapshotPublishModal {...modal} />

      <Triptych
        list={(
          <CatalogSnapshotList
            selectedRowItem={selectedItem}
            onRowPress={(item) => triptych.close({ data: item, mode: 'UPDATE' })}
            onPreview={onPreview}
            onPublish={(catalogSnapshot) => modal.open({ catalogSnapshotId: catalogSnapshot._id })} />
        )}
        form={<CatalogSnapshotShow toggle={() => triptych.close()} />} />
    </MainLayout>
  );
};

